import * as React from "react";
import type { SVGProps } from "react";
const SvgMoneyBanknotes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.747 14.751a.25.25 0 1 0 .001.5.25.25 0 0 0-.001-.5M10 13.5a1.5 1.5 0 1 1 0 3.002 1.5 1.5 0 0 1 0-3.001"
    />
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.002 12v6.003a2 2 0 0 1-2 2H4.995a2 2 0 0 1-2-2v-6.004a2 2 0 0 1 2.001-2h10.005a2 2 0 0 1 2 2.001"
      clipRule="evenodd"
    />
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.252 15.251a.25.25 0 1 0-.001-.5.25.25 0 0 0 0 .5"
    />
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6.196 10 1.21-4.52h0a2 2 0 0 1 2.45-1.415l9.664 2.59h.001a2 2 0 0 1 1.414 2.45l-1.554 5.798a1.997 1.997 0 0 1-2.379 1.427"
    />
  </svg>
);
export default SvgMoneyBanknotes;
